import { render, staticRenderFns } from "./list-content-form.vue?vue&type=template&id=5243de79"
import script from "./list-content-form.vue?vue&type=script&lang=js"
export * from "./list-content-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports